import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryTab,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeUserGroups } from '../actions/usergroups/read';
import UserGroupsActions from '../containers/UserGroupsActions';
import UserGroupsPanel from '../components/UserGroupsPanel';

export default {
  ...tabTemplate('usergroups', UserGroupsPanel, matchSingleUrl(['usergroups']), UserGroupsActions),
  ...tabCloser('closeUserGroupsTab', closeUserGroups),
  ...tabIcons('users'),
  access: ({ usergroups }) => usergroups.read,
  componentState: ({ url }) => categoryTab(url, 'all'),
  order: 850,
  position: 'top-right',
};
